import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router'
import {
  Avatar,
  AvatarGroup,
  BreadcrumbsUi,
  Divider,
  type IAvatarInfo,
  IconButton,
  Typography,
} from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ConversationsPath } from 'pages/conversations/route/conversationsPath'
import { useConversationsPageLayoutContext } from 'pages/conversations/context/conversationsPageLayoutContext'
import { useProfilePageContext } from 'pages/conversations/pages/search/pages/profile/context/profileContext'
import styles from './styles.module.scss'

export const HeaderProfile = observer(() => {
  const store = useProfilePageContext()
  const { contactsStore } = useEntitiesContext()
  const { pageLayoutStore } = useConversationsPageLayoutContext()
  const { titleIconProps, headerMenuTooltipIconProps, headerMenuIconAction } = pageLayoutStore
  const contact = store.contact
  const conversation = store.sectionConversationStore.conversation || store.conversation
  const contactsInfo = conversation?.contactsIds.reduce<IAvatarInfo[]>((state, id) => {
    const contact = contactsStore.getItem(id)

    if (contact) state.push(contact.avatarInfo)

    return state
  }, []) || [contact.avatarInfo]
  const { search } = useLocation()
  const queryParams = new URLSearchParams(search)
  const path = () => {
    if (queryParams.size) {
      queryParams.delete('contactId')
      queryParams.delete('messageId')

      return `/${ConversationsPath.search}?${queryParams.toString()}`
    }

    return `/${ConversationsPath.search}`
  }

  const renderTitle = () => {
    if (conversation?.isGroup) {
      return (
        <>
          <AvatarGroup items={contactsInfo} size={32} />
          <Typography
            ellipsis
            className={styles.info__name}
            ariaLabel={'name'}
            variant={'body-lg-medium'}
          >
            {conversation.title}
          </Typography>
        </>
      )
    }

    return (
      <>
        <Avatar info={store.contact} fontSize={12} size={24} />

        <Typography
          ellipsis
          className={styles.info__name}
          ariaLabel={'name'}
          variant={'body-lg-medium'}
        >
          {store.contact.name}
        </Typography>
      </>
    )
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.top}>
        <BreadcrumbsUi className={styles.breadcrumbs} path={path()} label={'Search results'} />
      </div>
      <div className={styles.bottom}>
        <div className={styles.bottom__box}>
          <IconButton
            iconProps={{
              fontSize: titleIconProps.fontSize,
              icon: titleIconProps.icon,
            }}
            tooltipProps={headerMenuTooltipIconProps}
            variant={'icon'}
            size={'medium'}
            color={'secondary'}
            onClick={headerMenuIconAction}
            ariaLabel='ContainerHeader_titleIcon'
          />
          <Divider orientation='vertical' style={{ height: '16px', margin: '4px' }} />

          <div className={styles.info}>{renderTitle()}</div>
        </div>

        <div className={styles.bottom__box}>
          <IconButton
            ariaLabel={'Close'}
            icon={'close'}
            variant={'contained'}
            color={'secondary'}
            onClick={store.onClose}
          />
        </div>
      </div>
    </div>
  )
})
